import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "PeopleBoot" */ './lazyIndex'),
    { name: 'PeopleBoot' }
);

export const lazyGetToDoBootstrapOptions = new LazyAction(
    lazyModule,
    m => m.getToDoBootstrapOptions
);
